import * as React from "react";

import { cn } from "@/infrastructure/lib/utils";

function Label({
  className,
  variant = "default",
  ...props
}: React.ComponentProps<"label"> & {
  variant?:
    | "default"
    | "body"
    | "medium"
    | "heading"
    | "success"
    | "error"
    | "muted";
}) {
  return (
    <label
      data-slot="label"
      className={cn(
        "flex items-center gap-2 text-xs leading-none select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        {
          default: "",
          body: "text-sm leading-5 font-normal",
          medium: "text-sm font-medium",
          heading: "text-base font-medium",
          success:
            "text-base font-medium text-success-foreground",
          error: "text-base font-medium text-destructive",
          muted: "text-muted-foreground",
        }[variant],
        className
      )}
      {...props}
    />
  );
}

export { Label };
